import { Address } from "../../types/travel/Policy";
const COUNTRY = "Singapore";

const formatToDisplayFloorAndUnitNumber = (floorNumber: string, unitNumber: string) => {
  if (!unitNumber && !floorNumber) return "";
  if (!floorNumber) return `#${unitNumber}`;
  if (!unitNumber) return `#${floorNumber}`;
  return `#${floorNumber}-${unitNumber}`;
};

const formatBuildingName = (hasFloorUnit: string, buildingName: string) => {
  return buildingName ? `${hasFloorUnit}${buildingName}` : "";
};

const formatToAddressLines = (address: Address): string[] => {
  const floorUnit = formatToDisplayFloorAndUnitNumber(address.floorNumber, address.unitNumber);

  const hasFloorUnit = address.floorNumber || address.unitNumber ? ", " : "";
  const building = formatBuildingName(hasFloorUnit, address.buildingName);

  return [`${address.number}, ${address.streetName}`, `${floorUnit}${building}`, `${COUNTRY} ${address.postalCode}`];
};

export default formatToAddressLines;
